// tutorial: translation of strings with a translation function $t
// translation of vee-validated error messages
const en = {
    'countryCode': 'en_en',
    'Account creation': 'Account creation',
    'Add address': 'Add address',
    'Address': 'Adress',
    'Address label': 'Address name',
    'Address label placeholder': 'for example, home, work...',
    'Amount': 'Amount',
    'Apply': 'Apply',
    'Apply discount': 'Apply discount',
    'Are you sure you want to delete this item from your shopping basket?': 'Are you sure you want to delete this item from your shopping basket?',
    'Are you sure you want to move this item to wishlist?': 'Are you sure you want to move this item to wishlist?',
    'Back': 'Back',
    'Back to cart': 'Back to cart',
    'Back to shopping': 'Back to shopping',
    'Back to store': 'Back to store',
    'Basket contents': 'Basket contents',
    'Billing address': 'Billing address',
    'Billing address is the same as the shipping address': 'Billing address is the same as the shipping address',
    'Buy now, pay later': 'Buy now, pay later',
    'Cannot apply Gift Card': 'Cannot apply Gift Card',
    'Card issuer authentication failed': 'Card issuer authentication failed',
    'Change': 'Change',
    'Change address': 'Change address',
    'Change e-mail address': 'Change e-mail address',
    'Change pickup point': 'Change pickup point',
    'Check zip code': 'Check zip code',
    'Choose a store for the pick-up in order to proceed': 'Choose a store for the pick-up in order to proceed',
    'Choose a zipcode in order to proceed': 'Choose a zipcode in order to proceed',
    'City': 'City',
    'Close': 'Close',
    'Closed': 'Closed',
    'Colour': 'Colour',
    'Complete your order': 'Complete your order',
    'Condizioni di vendita': 'Conditions of sale',
    'Confirm': 'Confirm',
    'Confirm password': 'Confirm password',
    'Continue': 'Continue',
    'Continue as guest': 'Continue as guest',
    'Continue with purchase': 'Continue with purchase',
    'Country': 'Country',
    'County/region': 'County/region',
    'Create account': 'Create account',
    'Credit Card': 'Credit Card',
    'Credit Card Number': 'Credit Card Number',
    'data': 'data',
    'Date of birth': 'Date of birth',
    'Date of Birth': 'Date of Birth',
    'dd/mm/yy': 'dd/mm/yy',
    'Delete': 'Delete',
    'Delivery': 'Delivery',
    'Delivery information': 'Delivery information',
    'Description': 'Description',
    'Do you have a discount code?': 'Do you have a discount code?',
    'Enter your Gift Card here': 'Enter your Gift Card here',
    'done': 'done',
    'E-mail': 'E-mail',
    'E-mail address': 'E-mail address',
    'E-mail address and telephone number': 'E-mail address and telephone number',
    'Edit': 'Edit',
    'Edit address': 'Edit address',
    'Edit basket': 'Edit basket',
    'Enter delivery information here': 'Enter delivery information here',
    'Enter shipping address': 'Enter shipping address',
    'Enter the points to be used here': 'Enter the points to be used here',
    'Enter your email address here to continue, and we will only send you information relating to your order': 'Enter your email address here to continue, and we will only send you information relating to your order',
    'Error during payment authorization': 'Error during payment authorization',
    'Error during registration': 'Error during registration',
    'Error occurred while placing orde': 'Error occurred while placing orde',
    'Expiry date': 'Expiry date',
    'Female': 'Female',
    'First name': 'First name',
    'Forgot your password?': 'Forgot your password?',
    'Free': 'Free',
    'Friday': 'Friday',
    'From': 'From',
    'Gender': 'Gender',
    'Gift Card': 'Gift Card',
    'Gift card and discount codes': 'Gift card and discount codes',
    'giftcardmsg': 'Giftcard {code}',
    'Glam card discount': 'Glam card discount',
    'Go to checkout': 'Go to checkout',
    'Go to shipping': 'Go to shipping',
    'Go to summary': 'Go to summary',
    'Have you forgotten your password?': 'Have you forgotten your password?',
    'Home delivery cost': 'Home delivery cost',
    'How many points do you want to use?': 'How many points do you want to use?',
    'How much bonus do you want to use?': 'How much bonus do you want to use?',
    'I accept the fidelity regulation and privacy policy': 'I accept the fidelity regulation and privacy policy',
    'I don\'t want to receive the invoice': 'I don\'t want to receive the invoice',
    'I want to receive the invoice': 'I want to receive the invoice',
    'Identical to shipping address': 'Identical to shipping address',
    'Insert here voucher code': 'Insert here voucher code',
    'Insert your billing address': 'Insert your billing address',
    'Invoice': 'Invoice',
    'Invoice address': 'Invoice address',
    'items': 'items',
    'Items present': 'Items present',
    'Last name': 'Last name',
    'Loading': 'Loading',
    'Loading payment form, please wait': 'Loading payment form, please wait',
    'Log in': 'Log in',
    'Male': 'Male',
    'Message': 'Message',
    'Mobile phone number': 'Mobile phone number',
    'Monday': 'Monday',
    'Move item': 'Move item',
    'Move product': 'Move product',
    'Name': 'Name',
    'New address': 'New address',
    'New client': 'New client',
    'No delivery methods available': 'No delivery methods available',
    'No items in basket': 'No items in basket',
    'No near stores': 'No near stores',
    'Not registered yet?': 'Not registered yet?',
    'OK': 'OK',
    'Or': 'Or',
    'Order detail': 'Order detail',
    'Order details': 'Order details',
    'Order placed': 'Order placed',
    'Order will be delivered to': 'Order will be delivered to',
    'Password': 'Password',
    'Pay': 'Pay',
    'Payment': 'Payment',
    'Payment error.': 'Payment error.',
    'Payment method not supported': 'Payment method not supported',
    'Personal details': 'Personal details',
    'Place of Birth': 'Place of Birth',
    'Please fill in your credit card details': 'Please fill in your credit card details',
    'Please select shipping from Amazon widget': 'Please select shipping from Amazon widget',
    'Please try again with another form of payment': 'Vuelva a intentarlo con otra forma de pago',
    'Please wait': 'Please wait',
    'Please wait, payment is processing': 'Please wait, payment is processing',
    'postcode': 'postcode',
    'Postcode': 'Postcode',
    'Proceed': 'Continue',
    'Prefix': 'Prefix',
    'product': 'product',
    'Product': 'Product',
    'products': 'products',
    'Purchase': 'Purchase',
    'Purchase now': 'Purchase now',
    'Quantity': 'Quantity',
    'Register': 'Register',
    'Registered User': 'Registered User',
    'Registration agreement': 'Registration agreement',
    'Registration successful': 'Registration successful',
    'registrationagreement': 'I accept the <a href="{linkfid}" target="_blank">fidelity regulation</a> and the <a href="{linkpriv}" target="_blank">privacy policy</a>',
    'Remove': 'Remove',
    'Remove discount': 'Remove discount',
    'Required fields': 'Required fields',
    'Retry': 'Retry',
    'Same as billing': 'Same as billing',
    'Saturday': 'Saturday',
    'Save': 'Save',
    'Save address': 'Save address',
    'Save in address book': 'Save in address book',
    'Save new address to proceed': 'Save new address to proceed',
    'Select': 'Select',
    'Select a city': 'Select a city',
    'Select a payment method': 'Select a payment method',
    'Select an address': 'Select an address',
    'Select delivery method': 'Select delivery method',
    'Select payment method': 'Select payment method',
    'Select store pickup': 'Select store pickup',
    'Select store pickup to procede': 'Select store pickup to procede',
    'Select the delivery method': 'Select the delivery method',
    'Select the store': 'Select the store',
    'Select this store': 'Select this store',
    'Select value': 'Select value',
    'Select your region': 'Select your region',
    'Select your shipping address here': 'Select your shipping address here',
    'Selected Store': 'Selected Store',
    'Send password recovery via e-mail': 'Send password recovery via e-mail',
    'Service unavailable, please try again later': 'Service unavailable, please try again later',
    'Session expired, page will reload': 'Session expired, page will reload',
    'Shipping address': 'Shipping address',
    'Shipping and handling': 'Shipping and handling',
    'Shop opening hours': 'Shop opening hours',
    'Shopping basket': 'Shopping basket',
    'Shopping Cart': 'Shopping Cart',
    'shopping details': 'shopping details',
    'Size': 'Size',
    'Something went wrong during Yandex Checkout': 'Please try again with another form of payment',
    'State/Region': 'District',
    'Store selection': 'Store selection',
    'street': 'street',
    'Street': 'Street',
    'Street number': 'Street number',
    'Summary': 'Summary',
    'Sunday': 'Sunday',
    'Surname': 'Surname',
    'Tax included': 'Tax included',
    'Telephone number': 'Telephone number',
    'Telephone number for courier / store pickup': 'Telephone number for courier / store pickup',
    'Terranova stores near you': 'Terranova stores near you',
    'The gift card is invalid or empty. Please check the gift card and try again': 'The gift card is invalid or empty. Please check the gift card and try again',
    'The maximum value of the usable We+Card bonus is': 'The maximum value of the usable WE Card bonus is',
    'The maximum value of the usable WE+Card points is': 'The maximum value of the usable WE Card points is',
    'The order is already been paid, please wait while order is placing': 'The order is already been paid, please wait while order is placing',
    'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).': 'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).',
    'The requested quantity is not available': 'The requested quantity is not available',
    'The voucher code is not valid. Check the code and try again': 'The voucher code is not valid. Check the code and try again',
    'There has been an error. Please try again': 'There has been an error. Please try again',
    'This e-mail address already exists. Log in or continue as a guest': 'This e-mail address already exists. Log in or continue as a guest',
    'This product is not available. Please remove it from your basket to continue': 'This product is not available. Please remove it from your basket to continue',
    'Thursday': 'Thursday',
    'To': 'To',
    'Total': 'Total',
    'Total products': 'Total products',
    'Tuesday': 'Tuesday',
    'Type of card': 'Type of card',
    'Update address': 'Update address',
    'Use points': 'Use points',
    'Use WE Card Bonus': 'Use WE Card Bonus',
    'Use WE+ points': 'Use WE Card points',
    'User': 'User',
    'Valid until': 'Valid until',
    'VAT number': 'VAT number',
    'Verify billing address': 'Verify billing address',
    'Verify Gift Card': 'Verify Gift Card',
    'Verify payment method selection': 'Verify payment method selection',
    'Verify shipping address': 'Verify shipping address',
    'Verify shipping method selection': 'Verify shipping method selection',
    'View your shopping basket': 'View your shopping basket',
    'Voucher': 'Voucher',
    'Voucher code': 'Voucher code',
    'Wait for page to reload': 'Wait for page to reload',
    'We have sent you an email to reset your password.': 'We have sent you an email to reset your password. Click on the link inside. ',
    'We were unable to send the password reset e-mail. Check the e-mail address you entered': 'We were unable to send the password reset e-mail. Check the e-mail address you entered',
    'Wednesday': 'Wednesday',
    'You are about to be redirected to the summary page': 'You are about to be redirected to the summary page',
    'You are delivering to a foreign country': 'You are delivering to a foreign country',
    'You are ordering with this email address': 'You are ordering with this email address',
    'Your available bonus': 'Your available bonus',
    'Your WE Card {bonus} points have been applied': 'Your WE Card {bonus} points have been applied',
    'Your WE Card points could not be applied': 'Your WE Card points could not be applied',
    'Zip or city': 'Zip or city',
    'weplus-pointstonext': 'You are missing {expense} of spending to reach the next level',
    '8 characters': '8 lowercase',
    '1 lowercase letter': '1 lowercase letter',
    '1 uppercase letter': '1 uppercase letter',
    '1 number': '1 number',
    '1 special character': '1 special character',
    'Now you can use your points': 'Now you can use your points',
    'Hallo': 'Hallo',
    'Save Credit Card (One Click Payment)': 'Save Credit Card (One Click Payment)',
    'Pay with a saved credit card': 'Pay with a saved credit card',
    'Pay with a new credit or debit card': 'Pay with a new credit or debit card',
    'Expiration': 'Expiration',
    'Other': 'Other',
    'Applied discounts': 'Applied discounts',
    'Choose size': 'Choose size',
    'amount-for-freeshipping': 'Spend just {amount} more to qualify for free shipping',
    'To proceed you must select a payment method': 'To proceed you must select a payment method',
    'To proceed you need to save the selected billing address': 'To proceed you need to save the selected billing address',
    'To proceed it is necessary to accept the general conditions of sale': 'To proceed it is necessary to accept the general conditions of sale',
    'To proceed you need to select the store': 'To proceed you need to select the store',
    'To proceed you need to save your changes': 'To proceed you need to save your changes',
    'Are you sure you want to delete this address?': 'Are you sure you want to delete this address?',
    'To proceed you need to save the selected shipping address': 'To proceed you need to save the selected shipping address',
    'message-double_optin_using_point_disabled': 'You cannot redeem points for this purchase as you have not yet confirmed the validity of your email or telephone number. For any doubts, please contact our customer care team.',
};

export default en;
export const enValidation = {
    name: "en",
    messages: {
        _default: function (e: any) {
            return "The value of the field " + e + " is not valid."
        },
        after: function (e: any, n: any) {
            return "The " + e + " must be after " + n[0] + "."
        },
        alpha: function (e: any) {
            return "The field " + e + " can contain only alphabetic characters."
        },
        alpha_dash: function (e: any) {
            return "The field " + e + " can contain alpha-numerical characters as well as dashes and underscores."

        },
        alpha_num: function (e: any) {
            return "The field " + e + " can contain only alpha-numerical characters."
        },
        alpha_spaces: function (e: any) {
            return "The field " + e + " can contain only alpha-numerical characters and spaces."
        },
        before: function (e: any, n: any) {
            return "The field " + e + " must be before " + n[0] + "."
        },
        between: function (e: any, n: any) {
            return "The field " + e + " must be between " + n[0] + " and " + n[1] + "."
        },
        confirmed: function (e: any, n: any) {
            return "The field " + e + " does not correspond with " + n[0] + "."
        },
        credit_card: function (e: any) {
            return "The field " + e + " is not valid."
        },
        date_between: function (e: any, n: any) {
            return "The " + e + " must be between " + n[0] + " and " + n[1] + "."
        },
        date_format: function (e: any, n: any) {
            return "The " + e + " must have the format " + n[0] + "."
        },
        decimal: function (e: any, n: any) {
            void 0 === n && (n = []);
            var r = n[0];
            return void 0 === r && (r = "*"), "The field " + e + " must be numerical and can contain" + (r && "*" !== r ? " " + r : "") + " decimal points."
        },
        digits: function (e: any, n: any) {
            return "The field " + e + " must be numerical and contain exactly " + n[0] + " digits."
        },
        dimensions: function (e: any, n: any) {
            return "The field " + e + " must be " + n[0] + " x " + n[1] + "."
        },
        email: function (e: any) {
            return "The field " + e + " must be a valid e-mail address."
        },
        excluded: function (e: any) {
            return "The field " + e + " must have a valid value."
        },
        ext: function (e: any) {
            return "The field " + e + " must be a valid file."
        },
        image: function (e: any) {
            return "The field " + e + " must be an image."
        },
        included: function (e: any) {
            return "The field " + e + " must have a valid value."
        },
        ip: function (e: any) {
            return "The field " + e + " must be a valid IP address."
        },
        length: function (e: any, n: any) {
            return "the length of the field " + e + " must be " + n[0] + "."
        },
        max: function (e: any, n: any) {
            return "The field " + e + " cannot be longer than " + n[0] + " characters."
        },
        max_value: function (e: any, n: any) {
            return "The field " + e + " must be less than or equal to " + n[0]
        },
        mimes: function (e: any) {
            return "The field " + e + " must be a valid file type."
        },
        min: function (e: any, n: any) {
            return "The field " + e + " must have at least " + n[0] + " characters."
        },
        min_value: function (e: any, n: any) {
            return "The field " + e + " must be greater than or equal to " + n[0]
        },
        numeric: function (e: any) {
            return "The field " + e + " can only contain numerical characters."
        },
        regex: function (e: any) {
            return "The field " + e + " does not have a valid format."
        },
        required: function (e: any) {
            return "This field " + e + " is required."
        },
        size: function (e: any, n: any) {
            return "The field " + e + " must be less than " + function (e) {
                const n = 1024;
                const r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / Math.pow(n, r)).toFixed(2));
                const v = 1 * f;
                return v.toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r]
            }(n[0]) + "."
        },
        url: function (e: any) {
            return "The field " + e + " is not a valid URL."
        },
        'validate-piva-cf': function (e: any) {
            return 'Invalid VAT identification number/fiscal code.';
        },
        'validate-regionid': function (e: any) {
            return 'The field Region is required.';
        },
        'validate-streetandnumber': function(e: any, n: any) {
            return 'Street and street number fields must not exceed {2} charachters';
        },
        'validate-data-consensus': function(e: any) {
          return 'Your consent is required for the processing of personal data.';
        },
        'validate-gender': function(e: any) {
            return 'The field Gender is required.';
        },
        'validate-password': function(e: any) {
            return 'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).';
        },
    },
    attributes: {}
};
